// src/config/freeMode.js
// ─────────────────────────────────────────────────────────────────────────────
// GLOBAL FREE MODE FLAG (frontend mirror)
// ─────────────────────────────────────────────────────────────────────────────
// Set FREE_MODE = true  → all users get Individual plan features for free.
//                         Teams plan UI (workspace, upgrade prompts) is hidden.
// Set FREE_MODE = false → full subscription gating is restored.
//
// IMPORTANT: When toggling this flag, also update the matching backend flag at:
//   screen-copilot-backend/app/free_mode.py
// ─────────────────────────────────────────────────────────────────────────────

export const FREE_MODE = false;
